<template>
    <div>
        <navTitle></navTitle>
        <router-view v-if="isRouterActive"></router-view>
        <footerCom></footerCom>
    </div>
</template>
<script>
import { defineComponent, defineAsyncComponent, ref, provide, nextTick } from "vue";

export default defineComponent({
    setup() {
        const isRouterActive = ref(true)
        provide('reload',()=>{
            isRouterActive.value = false
            nextTick(()=>{
                isRouterActive.value = true
            })
        })
        return {
            isRouterActive,
        };
    },
    components: {
        navTitle: defineAsyncComponent(() =>
            import("@/components/nav_com.vue")
        ),
        footerCom: defineAsyncComponent(() =>
            import("@/components/footer_com.vue")
        ),
        // Swiper,
        // SwiperSlide,
    },
});
</script>

<style lang="less">

</style>